import {
  IFormFieldSubmission,
  IFieldSubmissionMap,
} from "@common/redux/formSubmission/interface";
import { FieldProps } from "../../FormFieldSelector/interfaces";
import {
  IPaymentInputFieldConfigurationClient,
  IPaymentInputFieldConfigurationServer,
  IViewPaymentFieldValues,
} from "../interface";
import { IRequiredSubData } from "./gatewayUtils";
import { ICalculativeInputFieldConfigurationClient } from "../../FormCalculativeInputField/interface";

export const transformPaymentInputFieldConfigClientToServer = (
  fieldConfigClient: IPaymentInputFieldConfigurationClient
): IPaymentInputFieldConfigurationServer => {
  const {
    initialValue,
    maxAmount,
    minAmount,
    paymentType,
    isSandBoxMode,
    website,
    transactionAmount,
    userEmail,
    userPhoneNumber,
    userFirstName,
    userPaymentDescription,
    paymentId,
    calculativeFieldId,
  } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    maxAmount,
    minAmount,
    paymentType,
    isSandBoxMode,
    website,
    transactionAmount,
    userEmail,
    userPhoneNumber,
    userPaymentDescription,
    userFirstName,
    paymentId,
    calculativeFieldId,
  };
  return fieldConfigServer;
};

export const transformPaymentInputConfigServerToClient = (
  fieldConfigServer: IPaymentInputFieldConfigurationServer
): IPaymentInputFieldConfigurationClient => {
  const {
    initialValue,
    maxAmount,
    minAmount,
    paymentType,
    isSandBoxMode,
    website,
    transactionAmount,
    userEmail,
    userPhoneNumber,
    userFirstName,
    userPaymentDescription,
    paymentId,
    calculativeFieldId,
  } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    maxAmount,
    minAmount,
    paymentType,
    isSandBoxMode,
    website,
    transactionAmount,
    userEmail,
    userPhoneNumber,
    userFirstName,
    userPaymentDescription,
    paymentId,
    calculativeFieldId,
  };

  return fieldConfigClient;
};

export const validatePaymentFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap,
  bulkUpdateSubmissionValues: (fieldIds: string[], fieldsMap: object[]) => void
): [boolean, string] => {
  let isValidated = true;
  let isPaymentErrorMessage = "";
  const { fieldValue, isRequired, fieldType } = fieldEditConfig;
  const { fieldSubmissionValue, localId } = fieldSubmissionData;
  const submissionValue = fieldSubmissionValue?.paymentValue?.amount || "";
  const selectedMerchant = fieldSubmissionValue?.paymentValue?.gateway || "";
  const fieldIDsData: string[] = [];
  const fieldsMapData: object[] = [];
  const userEmail = fieldValue?.userEmail ?? "";
  const userPhoneNumber = fieldValue?.userPhoneNumber ?? "";
  const userFirstName = fieldValue?.userFirstName ?? "";
  const transactionAmount = fieldValue?.transactionAmount ?? "";
  const checkFieldIds = [userEmail, userPhoneNumber, userFirstName];

  if (isRequired) {
    if ((!submissionValue && !transactionAmount) || !selectedMerchant) {
      isValidated = false;
      isPaymentErrorMessage = "The amount and payment mode are required";
      // return [false, "The amount and payment mode are required"];
    }
  }

  checkFieldIds.forEach((fieldId) => {
    const submissionData = fieldSubmissionMap[fieldId];
    let isError = false;
    let errorMessage = "";
    if (!submissionData?.fieldSubmissionValue?.value) {
      isError = true;
      isValidated = false;
      isPaymentErrorMessage = isPaymentErrorMessage
        ? isPaymentErrorMessage
        : "Tagged Email/Phone Number is required";
      errorMessage = "Value is required for payment";
    }
    const fieldInitialization = {
      localId: fieldId,
      fieldType: submissionData?.fieldType,
      isError,
      valueError: errorMessage,
    };
    fieldIDsData.push(fieldId);
    fieldsMapData.push(fieldInitialization);
  });

  const fieldErrorInitialization = {
    localId,
    fieldType,
    isError: false,
    valueError: "",
  };
  fieldIDsData.push(localId);
  fieldsMapData.push(fieldErrorInitialization);
  bulkUpdateSubmissionValues(fieldIDsData, fieldsMapData);
  return [isValidated, isPaymentErrorMessage];
};

export const getPaymentFieldConfigValue = (
  fieldValueConfig: IPaymentInputFieldConfigurationClient,
  isDisabled: boolean
): IViewPaymentFieldValues => {
  const paymentId: string[] = fieldValueConfig?.paymentId;
  const initialValue = !isDisabled ? fieldValueConfig?.initialValue ?? "" : "";
  const transactionAmount = `${fieldValueConfig?.transactionAmount ?? ""}`;
  const maxAmount: number =
    !isNaN(parseInt(fieldValueConfig?.maxAmount)) &&
    parseInt(fieldValueConfig?.maxAmount);

  const minAmount: number =
    !isNaN(parseInt(fieldValueConfig?.minAmount)) &&
    parseInt(fieldValueConfig?.minAmount);
  const userEmailFieldId = fieldValueConfig?.userEmail ?? "";
  const userPhoneNumberFieldId = fieldValueConfig?.userPhoneNumber ?? "";
  const userFirstNameId = fieldValueConfig?.userFirstName ?? "";
  const userPaymentDescription = fieldValueConfig?.userPaymentDescription ?? "";
  const calculativeFieldId = fieldValueConfig?.calculativeFieldId ?? "";
  const returnUrl = fieldValueConfig?.calculativeFieldId ?? "";
  const updatedFieldValueConfig: IViewPaymentFieldValues = {
    initialValue,
    maxAmount,
    minAmount,
    paymentId,
    transactionAmount,
    userEmailFieldId,
    userFirstNameId,
    userPaymentDescription,
    userPhoneNumberFieldId,
    calculativeFieldId,
    returnUrl,
  };

  return updatedFieldValueConfig;
};

export const validatePaymentFieldData = (
  fieldConfigClient: IPaymentInputFieldConfigurationClient
) => {
  if (!fieldConfigClient) return;
  let ismerchantDataCompleted = true;

  const requiredpaymentData = [
    "userEmail",
    "userPhoneNumber",
    "userFirstName",
    "userPaymentDescription",
  ];

  const removeEmptyData = (data) => {
    const updatedData = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const updatedFieldConfigData = removeEmptyData(fieldConfigClient);

  const validateFieldConfigData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            validateFieldConfigData(subdata, updatedProfileData[data.key]);
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      ismerchantDataCompleted = false;
    }
  };
  validateFieldConfigData(requiredpaymentData, updatedFieldConfigData);

  const paymentType = fieldConfigClient?.paymentType;
  const transactionAmount = fieldConfigClient?.transactionAmount;
  const minAmount = fieldConfigClient?.minAmount;
  const maxAmount = fieldConfigClient?.maxAmount;
  const calculativeFieldId = fieldConfigClient?.calculativeFieldId;

  if (paymentType == "transactionAmount" && !transactionAmount) {
    ismerchantDataCompleted = false;
  } else if (paymentType == "userDefined" && (!minAmount || !maxAmount)) {
    ismerchantDataCompleted = false;
  } else if (paymentType === "tagFields" && !calculativeFieldId) {
    ismerchantDataCompleted = false;
  }

  const paymentId = fieldConfigClient?.paymentId || [];
  if (paymentId.length == 0) {
    ismerchantDataCompleted = false;
  }

  return ismerchantDataCompleted;
};

export const validateFormulaFieldData = (
  fieldConfigClient: ICalculativeInputFieldConfigurationClient
) => {
  if (!fieldConfigClient) return;
  const ismerchantDataCompleted = true;
  if (Object.keys(fieldConfigClient).length === 0) {
    return false;
  }
  const expression = fieldConfigClient?.expression || [];
  if (expression?.length === 0) {
    return false;
  }
  return ismerchantDataCompleted;
};
